export enum Protocol {
  Email = 'email',
  Webhook = 'https'
}
